// extracted by mini-css-extract-plugin
module.exports = {"commentsBoxContainer":"OrderExpanded_commentsBoxContainer__mAA_b"};